import script from "./TressAccordionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccordionItem.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccordionItem.vue?vue&type=style&index=0&id=49347c26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49347c26"]])

export default __exports__